import { postRequest } from 'components/Common/Utils';
import React, { Component, useEffect, useState } from 'react';
import { Card, CardBody, Row, Col, CardTitle, ListGroup, ListGroupItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import StockAlretTable from './StockAlretTable';

const TopAnalyticList = () => {
    let history = useHistory();
    const [topProduct, setTopProduct] = useState([]);
    const [topManufactures, setTopManufactures] = useState([]);
    const [topUsers, setTopUsers] = useState([]);
    const [topShops, setTopShops] = useState([]);

    const fetchToplist = async () => {
        try {
            const res = await postRequest('analytics/top');
            if (res.status) {
                console.log(res);
                setTopProduct(res?.data?.productlist);
                setTopManufactures(res?.data?.manufactureList);
                setTopUsers(res?.data?.userList);
                setTopShops(res?.data?.shoplist);
            }
        } catch (error) {

        }
    }

    // const fetchManufactureslist = async () => {
    //     try {
    //         const res = await postRequest('analytics/top-manufactures');
    //         if (res.status) {
    //             console.log(res);
    //             setTopManufactures(res?.data)
    //         }
    //     } catch (error) {

    //     }
    // }
    // const fetchUserslist = async () => {
    //     try {
    //         const res = await postRequest('analytics/top-users');
    //         if (res.status) {
    //             console.log(res);
    //             setTopUsers(res?.data)
    //         }
    //     } catch (error) {

    //     }
    // }
    // const fetcShopslist = async () => {
    //     try {
    //         const res = await postRequest('analytics/top-shops');
    //         if (res.status) {
    //             console.log(res);
    //             setTopShops(res?.data)
    //         }
    //     } catch (error) {

    //     }
    // }

    useEffect(() => {
        fetchToplist();
        // fetchManufactureslist();
        // fetchUserslist();
        // fetcShopslist();
    }, [])


    return (
        <React.Fragment>
              <Row className='top-analtics'>
                <Col xl={12}>
                    <Card>
                        <CardTitle>
                           <h4>Product Stock Alert</h4>
                        </CardTitle>
                        <CardBody className='mt-3' style={{height : 'auto', overflow : 'hidden'}}>
                            <StockAlretTable />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row className='top-analtics'>
                <Col xl={3}>
                    <Card>
                        <CardTitle>
                            <h4>Top Products</h4>
                        </CardTitle>
                        <CardBody>
                            <ul className='top-product'>
                                {topProduct?.map((item, index) => {
                                    return (
                                        <li className='flex-item'>
                                            <div>
                                                <img width='50px' src={item?.image} />
                                            </div>
                                            <div>
                                                {item?.name}
                                            </div>
                                            <button onClick={() => history.push(`product-details/${item?._id}`)} type='button' className='btn btn-secondary btn-sm'>
                                                <i className='fal fa-eye'></i>
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3}>
                    <Card>
                        <CardTitle style={{ background: '#2ecc71' }}>
                            <h4>Top Manufactures</h4>
                        </CardTitle>
                        <CardBody>
                            <ul className='top-product'>
                                {topManufactures?.map((item, index) => {
                                    return (
                                        <li className='flex-item'>
                                            <div>
                                                <img width='50px' src={item?.image} />
                                            </div>
                                            <div>
                                                {item?.name}
                                            </div>
                                            <button type='button' onClick={() => history.push(`manufacturers-details/${item?._id}`)} className='btn btn-secondary btn-sm'>
                                                <i className='fal fa-eye'></i>
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3}>
                    <Card>
                        <CardTitle style={{ background: '#e67e22' }}>
                            <h4>Top Users</h4>
                        </CardTitle>
                        <CardBody>
                            <ul className='top-product'>
                                {topUsers?.map((item, index) => {
                                    return (
                                        <li className='flex-item'>
                                            <div>
                                                <img width='50px' src={item?.image} />
                                            </div>
                                            <div>
                                                {item?.name}
                                            </div>
                                            <button type='button' onClick={() => history.push(`userdetails/${item?._id}`)} className='btn btn-secondary btn-sm'>
                                                <i className='fal fa-eye'></i>
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Col>

                <Col xl={3}>
                    <Card>
                        <CardTitle style={{ background: '#3498db' }}>
                            <h4>Top Shops</h4>
                        </CardTitle>
                        <CardBody>
                            <ul className='top-product'>
                                {topShops?.map((item, index) => {
                                    return (
                                        <li className='flex-item'>
                                            <div>
                                                <img width='50px' src={`https://ui-avatars.com/api/?background=random&name=${item?.name}`} />
                                            </div>
                                            <div>
                                                {item?.name}
                                            </div>
                                            <button onClick={() => history.push(`userdetails/${item?._id}`)} type='button' className='btn btn-secondary btn-sm'>
                                                <i className='fal fa-eye'></i>
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </CardBody>
                    </Card>
                </Col>

            </Row>

          

        </React.Fragment>
    );
}

export default TopAnalyticList;